import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Api} from '../../providers/api';
import {NgxSpinnerService} from 'ngx-spinner';
import {NgbDropdownConfig} from '@ng-bootstrap/ng-bootstrap';
import {types} from '../../providers/data';

@Component({
  selector: 'app-upload-form',
  templateUrl: './upload-form.component.html',
  styleUrls: ['./upload-form.component.css']
})
export class UploadFormComponent implements OnInit {

  @Output()
  onclose = new EventEmitter();
  @Output()
  showFile = new EventEmitter();
  @Input('newFrame')
  newFrame;

  @Input('circuito')
  circuito;

  tipos = types;

  newFrame_nombre;
  newFrame_texto;
  newFrame_idTipo;
  newFrame_duracion = 20;

  incomplete = true;

  constructor(config: NgbDropdownConfig, private api: Api, private spinner: NgxSpinnerService) {
    config.autoClose = true;
  }

  ngOnInit() {
    this.newFrame_nombre = this.newFrame.nombre;
    this.newFrame_idTipo = 0;
  }

  showSubirArchivo() {
    this.newFrame.idCircuito = this.circuito;
    this.newFrame.nombre = this.newFrame_idTipo.type === 'news-frame' ? this.newFrame_texto : this.newFrame_nombre;
    this.newFrame.idTipo = this.newFrame_idTipo.id;
    this.newFrame.segundos = this.newFrame_duracion;
    this.showFile.emit(this.newFrame);
  }

  close() {
    this.onclose.emit();
  }

  selectTipo(tipo) {
    this.newFrame_idTipo = tipo;
    console.log(this.newFrame_idTipo);
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/upload-form/upload-form.component.ts